// extracted by mini-css-extract-plugin
export var cost = "happens-module--cost--3izMD";
export var cost__second = "happens-module--cost__second--1mQfV";
export var cost__wrap = "happens-module--cost__wrap--3OdPs";
export var cost__section = "happens-module--cost__section--2p1eF";
export var cost__section__image = "happens-module--cost__section__image--3GPSA";
export var info__section__image__bg = "happens-module--info__section__image__bg--3483D";
export var cost__section__image__bg = "happens-module--cost__section__image__bg--2EGt0";